// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2366":"963101bb","4759":"cc00fa56","6790":"9e962f7a"}[chunkId] + ".chunk.css";
};